import React from 'react';
import { DumbbellIcon, GlobeIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-orange-100 bg-white px-4 py-12" data-id="element-217" data-mp="3gfitoga0y7d2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-218" data-mp="32nuh6bvv5gvk">
        <p className="inline-flex items-center gap-2 font-display text-lg font-bold text-primary" data-id="element-219" data-mp="32pfgsfx1bq0a">
          <DumbbellIcon className="h-5 w-5 text-accent" data-id="element-220" data-mp="36pz9n7aks7gm" /> COMPRA DIGITAL YA™
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-221" data-mp="3ugbqx8rpngjv">
          El sistema N°1 para profesores de educación física, entrenadores personales, kinesiólogos
          y centros de jubilados en Argentina.
        </p>
        <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-222" data-mp="3ldu874b9l61m">
          Porque trabajar con adultos mayores merece tener un sistema real.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-medium text-slate-600 sm:flex-row sm:gap-6" data-id="element-223" data-mp="29ynnbq7ctfgn">
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-accent" href="mailto:compradigitalya@gmail.com" data-id="element-224" data-mp="2ez1nkm2prl44">
            <MailIcon className="h-4 w-4" data-id="element-225" data-mp="3gb8vj0znlauj" /> compradigitalya@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-accent" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-226" data-mp="3v7gg42ez4eac">
            <GlobeIcon className="h-4 w-4" data-id="element-227" data-mp="81pgvn5hf5bh" /> www.compradigitalya.com
          </a>
        </div>
        <p className="mt-7 border-t border-orange-100 pt-6 text-xs font-medium text-slate-400" data-id="element-228" data-mp="32w45wy0ricd">
          © CompraDigitalYa™ 2025 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}